import { getEnvMode } from "@/lib/envMode";

/**
 * Compact pill rendered on the login screen and (optionally) anywhere else
 * that needs a quick "which environment am I on?" signal.
 *
 * - LIVE: green dot, "Live site" — discreet, doesn't shout at users
 * - TEST: amber dot, "Test / demo site" — loud enough to never confuse with
 *   the real system
 */
export default function EnvBadge({ className = "" }) {
  const mode = getEnvMode();
  const isLive = mode === "live";
  // Phase 7: In production we hide the badge entirely — users on a live
  // school instance should see ZERO "test/demo" chrome. The pill is purely
  // a non-prod safety signal so admins / QA never confuse environments.
  if (isLive) return null;
  return (
    <span
      data-testid={`env-badge-${mode}`}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold border bg-mustard-soft border-mustard-hover/40 text-ink ${className}`}
    >
      <span className="inline-block w-2 h-2 rounded-full bg-mustard-hover animate-pulse" />
      Test / demo site
    </span>
  );
}
